import { Pipe, PipeTransform } from '@angular/core';
import { MeterView } from '@app/shared/models/meter-data/meter-view';
import { isEmpty, isNil } from 'lodash';

@Pipe({
  name: 'getAddress',
})
export class GetAddressPipe implements PipeTransform {
  transform(value: MeterView | undefined | null): string {
    if (isNil(value) || isEmpty(value)) {
      return '';
    }

    const streetLine = [value.street, value.houseNumber].filter(Boolean).join(' ').trim();
    const cityLine = [[value.zipCode, value.municipality].filter(Boolean).join(' '), value.district].filter(Boolean).join(', ').trim();

    return `${streetLine},\r\n${cityLine}`;
  }
}
